export const OMEGA_AMS_WS_URL = import.meta.env.VITE_OMEGA_AMS_WS ?? '';
export const TOURNAMENTS_TIMEZONE_OFFSET_HOURS = import.meta.env.VITE_TOURNAMENTS_TIMEZONE_OFFSET_HOURS ?? 7;